import { Chart } from '@antv/g2'
import { CreateElement } from 'vue'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { PonitXY, BaseBarCfg, G2TooltipCfg } from '@/types/common/g2Charts'
import { comdify2 } from '@/utils/validate'
import { g2DefaultCfg } from '../config'

const { tooltipText, YAxisFn, annotationTextFn } = g2DefaultCfg

@Component
export default class BarChart extends Vue {
  @Prop({ default: 500 }) height!: number
  @Prop() data!: PonitXY[]
  @Prop() options!: BaseBarCfg
  id = 'chart' + (Math.floor(Math.random() * 1000000) + 1)
  render (h: CreateElement) {
    return h('div', {
      attrs: {
        id: this.id
      }
    })
  }

  @Watch('data', {
    deep: true
  })
  watchHandleChart () {
    this.chart()
  }

  chart () {
    const { chartCfgFn } = g2DefaultCfg

    const { data, options } = this
    const {
      annotationContent,
      tooltipContext,
      titleNextContent,
      position
    } = options
    const chart = new Chart({
      container: this.id,
      ...chartCfgFn([50, 50, 50, 100])
    })
    chart.data(data)
    chart.scale({
      y: {
        min: 0,
        formatter: (val: number | string) => {
          let _val = ''
          if (typeof val === 'number') {
            _val = val + ''
          } else {
            _val = val
          }
          return comdify2(_val)
        }
      }
    })
    chart.tooltip({
      showMarkers: false,
      shared: true
    })
    chart.interval().position('x*y')
    chart.axis('y', YAxisFn())
    chart.annotation().text({
      position,
      content: annotationContent,
      ...annotationTextFn({ offsetY: -20 })
    })
    chart.tooltip({
      showCrosshairs: true,
      customContent (title: string, data: G2TooltipCfg[]) {
        return tooltipText(
          title + (titleNextContent || ''),
          data,
          tooltipContext
        )
      }
    })

    chart.interaction('element-visible-filter')

    chart.render()
  }
}
